module.exports = __webpack_public_path__ + "images/newerp_icon1.1789440611829.png";